import { render, staticRenderFns } from "./RefinementTaskCard.vue?vue&type=template&id=23428ec4&scoped=true"
import script from "./RefinementTaskCard.vue?vue&type=script&lang=js"
export * from "./RefinementTaskCard.vue?vue&type=script&lang=js"
import style0 from "./RefinementTaskCard.vue?vue&type=style&index=0&id=23428ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23428ec4",
  null
  
)

export default component.exports